import { Helpers } from '../../helpers';
import { IAreaType } from '../../interfaces/iarea-type';
import { Area } from '../area';
import { ConstraintCalendarRestriction } from '../constraint-calendar-restriction';
import { ConstraintFacilityConstrainedSchedule } from '../constraint-facility-constrained-schedule';
import { ConstraintFacilityExpansion } from '../constraint-facility-expansion';
import { ConstraintFacilityInitialBuild } from '../constraint-facility-initial-build';
import { ConstraintFacilityTruck } from '../constraint-facility-truck';
import { ConstraintManualObligation } from '../constraint-manual-obligation';
import { ConstraintMaxFracFleetPerArea } from '../constraint-max-frac-fleet-per-area';
import { ConstraintMinMaxRigsPerArea } from '../constraint-min-max-rigs-per-area';
import { ConstraintProvenUndrilledObligation } from '../constraint-proven-undrilled-obligation';
import { ConstraintSpudLimit } from '../constraint-spud-limit';

export class AreaTypeBase {
  AreaTypeId: number;
  Description: string;
  SortOrder: number | null;
  WellFieldName: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_AreaType?: Array<Area> | null;
  ConstraintCalendarRestrictions_AreaType?: Array<ConstraintCalendarRestriction> | null;
  ConstraintFacilityConstrainedSchedules_AreaType?: Array<ConstraintFacilityConstrainedSchedule> | null;
  ConstraintFacilityExpansions_AreaType?: Array<ConstraintFacilityExpansion> | null;
  ConstraintFacilityInitialBuilds_AreaType?: Array<ConstraintFacilityInitialBuild> | null;
  ConstraintFacilityTrucks_AreaType?: Array<ConstraintFacilityTruck> | null;
  ConstraintManualObligations_AreaType?: Array<ConstraintManualObligation> | null;
  ConstraintMaxFracFleetPerAreas_AreaType?: Array<ConstraintMaxFracFleetPerArea> | null;
  ConstraintMinMaxRigsPerAreas_AreaType?: Array<ConstraintMinMaxRigsPerArea> | null;
  ConstraintProvenUndrilledObligations_AreaType?: Array<ConstraintProvenUndrilledObligation> | null;
  ConstraintSpudLimits_AreaType?: Array<ConstraintSpudLimit> | null;

  constructor(item?: IAreaType) {
    if (item) {

      this.AreaTypeId = item.AreaTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.WellFieldName = item.WellFieldName;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_AreaType = Helpers.createClassArray(Area, item.Areas_AreaType);
      this.ConstraintCalendarRestrictions_AreaType = Helpers.createClassArray(ConstraintCalendarRestriction, item.ConstraintCalendarRestrictions_AreaType);
      this.ConstraintFacilityConstrainedSchedules_AreaType = Helpers.createClassArray(ConstraintFacilityConstrainedSchedule, item.ConstraintFacilityConstrainedSchedules_AreaType);
      this.ConstraintFacilityExpansions_AreaType = Helpers.createClassArray(ConstraintFacilityExpansion, item.ConstraintFacilityExpansions_AreaType);
      this.ConstraintFacilityInitialBuilds_AreaType = Helpers.createClassArray(ConstraintFacilityInitialBuild, item.ConstraintFacilityInitialBuilds_AreaType);
      this.ConstraintFacilityTrucks_AreaType = Helpers.createClassArray(ConstraintFacilityTruck, item.ConstraintFacilityTrucks_AreaType);
      this.ConstraintManualObligations_AreaType = Helpers.createClassArray(ConstraintManualObligation, item.ConstraintManualObligations_AreaType);
      this.ConstraintMaxFracFleetPerAreas_AreaType = Helpers.createClassArray(ConstraintMaxFracFleetPerArea, item.ConstraintMaxFracFleetPerAreas_AreaType);
      this.ConstraintMinMaxRigsPerAreas_AreaType = Helpers.createClassArray(ConstraintMinMaxRigsPerArea, item.ConstraintMinMaxRigsPerAreas_AreaType);
      this.ConstraintProvenUndrilledObligations_AreaType = Helpers.createClassArray(ConstraintProvenUndrilledObligation, item.ConstraintProvenUndrilledObligations_AreaType);
      this.ConstraintSpudLimits_AreaType = Helpers.createClassArray(ConstraintSpudLimit, item.ConstraintSpudLimits_AreaType);
    }
  }
}